import { fg } from '@atlaskit/platform-feature-flags/fg';

import { DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI } from '../../../types/default-cloud-graph-devinfo-repository-entity-ati';
import { DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI } from '../../../types/default-cloud-graph-remote-link-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import {
	NounSubtypeKey,
	type TypeFilterValue3PEntities,
	TypeFilterValueKey,
} from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';
import { GitlabIcon, GitlabIconBorderless, GitlabSearchResultIcon } from './icon';

const getGitlabTypeFilterConfig = () => {
	const config = new Map<TypeFilterValueKey, TypeFilterValue3PEntities>();
	config.set(TypeFilterValueKey.Repository, {
		entities3P: [
			...DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI,
			...DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
		],
		subTypes3P: [NounSubtypeKey.Repository, NounSubtypeKey.Project],
	});
	if (fg('rovo-fps-3p-ux-gitlab-pull-request-noun')) {
		config.set(TypeFilterValueKey.PullRequest, {
			entities3P: [...DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI],
			subTypes3P: [NounSubtypeKey.PullRequest],
		});
	}
	return config;
};

export const gitlabConfig: ThirdPartyConfig = {
	displayName: 'Gitlab',
	id: 'gitlab',
	resourceType: ProductResourceTypes3P.Gitlab,
	icon: get3PLogo(GitlabIcon, 'Gitlab', 'medium'),
	iconBorderless: get3PLogo(GitlabIconBorderless, 'Gitlab', 'small'),
	searchResultIcon: get3PLogo(GitlabSearchResultIcon, 'Gitlab', 'large'),
	integrationAri: 'ari:cloud:platform::integration/gitlab',
	get typeFilterConfig() {
		return getGitlabTypeFilterConfig();
	},
	filters: ['pullRequestStatus'],
	requiresOauth: true,
	isEnabled: () => true,
};
